import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQSection = () => {
  const faqs = [
    {
      question: "Will AI and robotics replace my employees?",
      answer:
        "No. Neil AI is built to support your workforce — not replace it. Our systems handle repetitive, high-burnout tasks so your team can focus on customers, sales, and the work that requires human judgment.",
    },
    {
      question: "What is the typical ROI timeline?",
      answer:
        "Most clients see measurable ROI within 60–120 days through reduced overtime, fewer staffing gaps, and higher operational consistency. We provide a custom ROI projection during your free consultation.",
    },
    {
      question: "Are the PUDU robots safe around staff and customers?",
      answer:
        "Yes. Every robot we deploy uses 3D LiDAR, multi-sensor obstacle avoidance, and certified safety protocols. Nick Eaton, our Certified PUDU Technology Specialist, oversees every deployment.",
    },
    {
      question: "Which industries do you serve?",
      answer:
        "Healthcare, hospitality, restaurants, warehousing, manufacturing, retail, senior living, schools, churches, and commercial cleaning — anywhere labor pressure, burnout, or operational inefficiency exists.",
    },
    {
      question: "How does onboarding and training work?",
      answer:
        "Every engagement includes white-glove deployment, on-site staff training, CRM integration, and ongoing U.S.-based support. You are never left to figure it out alone.",
    },
    {
      question: "Can your AI integrate with my existing CRM and tools?",
      answer:
        "Yes. We integrate with Go High Level, HubSpot, Salesforce, Zapier, Make, Twilio, Stripe, and most major business platforms. Custom integrations are available on Growth and Dominate tiers.",
    },
    {
      question: "What about data privacy and compliance?",
      answer:
        "Explicit opt-in consent, DNC compliance, encrypted data storage, audit logs, and GDPR/CCPA-aligned controls are built in. Healthcare clients receive HIPAA-aware workflow design.",
    },
    {
      question: "Do you offer financing on robotics?",
      answer:
        "Yes. We partner with Ascentium Capital to offer flexible financing on every PUDU robot — starting as low as $349/mo with approved credit.",
    },
  ];

  return (
    <section className="py-20 space-y-10">
      <div className="text-center space-y-4 max-w-3xl mx-auto px-4">
        <p className="text-xs md:text-sm font-bold tracking-[0.25em] text-primary">
          FREQUENTLY ASKED
        </p>
        <h2 className="font-orbitron font-bold text-3xl md:text-5xl text-foreground leading-tight">
          Answers for{" "}
          <span className="text-primary">Operations Leaders</span>
        </h2>
        <p className="text-base md:text-lg text-muted-foreground">
          Everything you need to know about deploying AI and robotics inside a real business.
        </p>
      </div>

      <div className="max-w-3xl mx-auto px-4">
        <Accordion type="single" collapsible className="w-full space-y-3">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="border border-[hsl(var(--line))] rounded-xl glass-effect px-5 data-[state=open]:border-primary/50 data-[state=open]:shadow-[0_0_24px_hsl(var(--primary)/0.18)] transition-all"
            >
              <AccordionTrigger className="text-left font-semibold text-foreground hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
